import React from 'react'
import { App, Button, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { useFetchTextAssignmentSubmissionsQuery } from '../../../../../store/apis/submission.api'
import { useParams } from 'react-router'
import { useTextSubmissionNavigation } from '../../../../../store/apis/utils/hooks/text-submission.hooks'
import useReviewFlow from '../../../../../review-flow/useReviewFlow'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import useShortcuts from './useShortcuts'

const TextSubmissionDrawerNavigation = () => {
    const { modal } = App.useApp()
    const { token } = useParams()
    const versionId = useVersionId()
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const { data: submissions } = useFetchTextAssignmentSubmissionsQuery({ token, versionId })

    const { navigateToPreviousSubmission, previousSubmissionExists, nextSubmissionExists } =
        useTextSubmissionNavigation()
    const { openNextSubmissionOrPrompt, canContinueToNextQuestionRubric, hasEarlierSkipped, returnToFirstSkipped, continueToNextQuestionRubric } = useReviewFlow()

    useShortcuts(submissions, openedSubmissionId, navigateToPreviousSubmission, openNextSubmissionOrPrompt)

    const handleNextClick = () => {
        if (!nextSubmissionExists && canContinueToNextQuestionRubric && hasEarlierSkipped) {
            modal.confirm({
                title: 'Skipped Answers Detected',
                content: 'You skipped some answers in this rubric. What would you like to do?',
                okText: 'Review skipped now',
                cancelText: 'Continue to next rubric',
                onOk: () => {
                    returnToFirstSkipped()
                },
                onCancel: () => {
                    continueToNextQuestionRubric()
                },
            })
            return
        }
        openNextSubmissionOrPrompt()
    }

    return (
        <Space.Compact size={8}>
            <Button
                icon={<LeftOutlined />}
                onClick={navigateToPreviousSubmission}
                title='Previous Submission'
                disabled={!previousSubmissionExists}
            />
            <Button
                icon={<RightOutlined />}
                onClick={handleNextClick}
                title='Next Submission'
                disabled={!(nextSubmissionExists || canContinueToNextQuestionRubric)}
            />
        </Space.Compact>
    )
}

export default TextSubmissionDrawerNavigation
